"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.SelectMultiInput = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../../styles");
var Input_1 = require("../../Input/Input");
var TextInputBase_1 = require("../../TextField/TextInputBase");
var SelectMultiItem_1 = require("./SelectMultiItem");
function SelectMultiInput(props) {
    var wrapperRef = props.wrapperRef, items = props.items, renderItem = props.renderItem, onRemoveItem = props.onRemoveItem, invalid = props.invalid, disabled = props.disabled, clearable = props.clearable, rest = __rest(props, ["wrapperRef", "items", "renderItem", "onRemoveItem", "invalid", "disabled", "clearable"]);
    var inputRef = react_1.useRef();
    var handleRemove = function (item) { return function (e) {
        props.onRemoveItem(item);
        e.stopPropagation(); // Do not propagate so menu is not opened when item is removed
    }; };
    var handleWrapperClick = function () { return inputRef.current.focus(); };
    var _a = styles_1.useStyles(exports.createStyles, props), classes = _a.classes, css = _a.css;
    var wrapperClasses = css(classes.wrapper, invalid && classes.invalid, props.disabled && classes.disabled);
    return (react_1.default.createElement("div", { ref: wrapperRef, className: wrapperClasses, onClick: handleWrapperClick },
        items &&
            items.map(function (item, key) { return (react_1.default.createElement(SelectMultiItem_1.SelectMultiItem, { key: key, onRemove: handleRemove(item), style: classes.item, disabled: disabled }, renderItem(item))); }),
        react_1.default.createElement(Input_1.Input, __assign({ type: 'text', inputRef: inputRef, className: classes.input, disabled: disabled }, rest))));
}
exports.SelectMultiInput = SelectMultiInput;
exports.createStyles = function (theme, _a) {
    var items = _a.items, disabled = _a.disabled;
    var parts = TextInputBase_1.createStyleParts(theme);
    return {
        wrapper: __assign(__assign({}, parts.base), { cursor: 'text', display: 'flex', flexWrap: 'wrap', alignItems: 'center', padding: items.length > 0 ? 'calc(0.25rem - 1px) 0.25rem' : 'calc(0.5rem - 1px) 0.5rem', '&:hover': !disabled && parts.hover, '&:active': !disabled && parts.active, '&:focus-within': !disabled && parts.focus }),
        disabled: parts.disabled,
        invalid: __assign(__assign({}, parts.invalid), { '&:focus-within': parts.invalid[':not(:disabled):focus'] }),
        item: {
            marginRight: '0.25rem',
        },
        input: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.sizes.text,
            color: theme.pallete.text.main,
            lineHeight: '1rem',
            background: theme.pallete.surface.main,
            padding: 0,
            flex: 1,
            border: 0,
            outline: 0,
            '::placeholder': parts.placeholder,
            ':disabled': parts.disabled,
        },
    };
};
//# sourceMappingURL=SelectMultiInput.js.map